import {
  AlertTitle as MuiAlertTitle,
  AlertTitleProps,
  styled,
} from '@mui/material';

const StyledAlertDescription = styled(MuiAlertTitle)<AlertTitleProps>(() => ({
  fontSize: '10px',
  fontWeight: 500,
  lineHeight: 1.5,
  color: 'inherit',
}));

export function AlertDescription(props: AlertTitleProps) {
  return <StyledAlertDescription {...props} />;
}

export default AlertDescription;
